import type { ProColumns } from "@ant-design/pro-components";
import type { TFunction } from "i18next";

const statusOptions = [
  { label: "草稿", value: 0 },
  { label: "部门评估中", value: 1 },
  { label: "部门评估完成", value: 2 },
  { label: "审批中", value: 3 },
  { label: "已驳回", value: 4 },
  { label: "已通过", value: 5 },
];

export function createTableColumns({
  t,
  userOptions,
  handleSearchUser,
}: {
  t: TFunction;
  userOptions: Array<{
    label: string;
    value: string;
  }>;
  handleSearchUser: (value: string) => void;
}): ProColumns<any>[] {
  return [
    {
      title: t("评估状态"),
      dataIndex: "evaluationStatus",
      key: "evaluationStatus",
      align: "center",
      valueType: "select",
      fieldProps: {
        options: statusOptions,
      },
      order: 95,
    },
    {
      title: t("供应商编号"),
      dataIndex: "supplierCode",
      key: "supplierCode",
      align: "center",
      order: 100,
    },
    {
      title: t("供应商名称"),
      dataIndex: "supplierUserName",
      key: "supplierUserName",
      align: "center",
      hideInTable: true,
      order: 99,
    },
    {
      title: t("供应商名称（中文）"),
      dataIndex: "supplierUserName",
      key: "supplierUserName",
      align: "center",
      search: false,
    },
    {
      title: t("供应商名称（英文）"),
      dataIndex: "supplierUsUserName",
      key: "supplierUsUserName",
      align: "center",
      search: false,
    },
    {
      title: t("物料状态"),
      dataIndex: "materialStatusName",
      key: "materialStatusName",
      align: "center",
      search: false,
    },
    {
      title: t("物料用途类别"),
      dataIndex: "materialCategoryName",
      key: "materialCategoryName",
      align: "center",
      search: false,
    },
    {
      title: t("物料名称"),
      dataIndex: "materialName",
      key: "materialName",
      align: "center",
      hideInTable: true,
      order: 96,
    },
    {
      title: t("物料编码"),
      dataIndex: "materialCode",
      key: "materialCode",
      align: "center",
      hideInTable: true,
      order: 97,
    },
    {
      title: t("申请人"),
      dataIndex: "purchaseUserId",
      key: "purchaseUserId",
      align: "center",
      valueType: "select",
      hideInTable: true,
      fieldProps: {
        options: userOptions,
        showSearch: true,
        filterOption: false,
        onSearch: (value: string) => handleSearchUser(value),
      },
      order: 94,
    },
    {
      title: t("评估发起人"),
      dataIndex: "purchaseUserNickname",
      key: "purchaseUserNickname",
      align: "center",
      search: false,
    },
    {
      title: t("发起时间"),
      dataIndex: "createTime",
      key: "createTime",
      align: "center",
      search: false,
    },
  ];
}
